const MuiIconButton = {
  root: {
    '&.MuiButtonBase-root.MuiIconButton-root': {
      padding: '8px',
      borderRadius: '50%',
    },
    '&.MuiButtonBase-root.MuiButton-root': {
      padding: '6px 16px',
      borderRadius: '4px',
    },
  },
};

export default MuiIconButton;
